<template>
  <v-card class="notes-filter-card">
    <v-card-title class="py-2">Filtros</v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <div class="filter-section-title">Estado</div>
          <v-row dense>
            <v-col cols="12">
              <v-checkbox v-model="localFilters.seenPending" label="Pendientes" hide-details></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-checkbox v-model="localFilters.seenRead" label="Leidas" hide-details></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-checkbox v-model="localFilters.seenDone" label="Realizadas" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <div class="filter-section-title">Fecha de creacion</div>
          <v-menu v-model="menuFrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="localFilters.dateFrom" label="Desde" clearable prepend-icon="mdi-calendar-today" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" v-model="localFilters.dateFrom" @input="menuFrom = false"></v-date-picker>
          </v-menu>
          <v-menu v-model="menuTo" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="localFilters.dateTo" label="Hasta" clearable prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" v-model="localFilters.dateTo" @input="menuTo = false"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" v-if="showCompanyFilter">
          <v-autocomplete v-model="localFilters.company_id" :items="companyLists" item-text="name" item-value="id" attach chips label="Empresa" multiple>
            <template slot="no-data" class="pa-2">No existen empresas relacionadas.</template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete v-model="localFilters.contact_id" :items="contactLists" item-text="name" item-value="id" attach chips label="Contacto" multiple>
            <template slot="no-data" class="pa-2">No existen contactos relacionados.</template>
            <template v-slot:item="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action class="mr-2">
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" v-if="!hideFromUser">
          <v-autocomplete v-model="localFilters.from_user_id" :items="userLists" item-text="name" item-value="id" attach chips label="De" multiple></v-autocomplete>
        </v-col>
        <v-col cols="12" v-if="!hideToUser">
          <v-autocomplete v-model="localFilters.to_user_id" :items="userLists" item-text="name" item-value="id" attach chips label="Para" multiple></v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="grey" @click="resetFilters">Limpiar</v-btn>
      <v-btn text color="primary" @click="applyFilters">Aplicar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    company: {
      type: [String, Object],
      default: null,
    },
    hideFromUser: {
      type: Boolean,
      default: false,
    },
    hideToUser: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localFilters: {},
    menuFrom: false,
    menuTo: false,
  }),
  computed: {
    showCompanyFilter() {
      return !this.company
    },
    companyLists() {
      return this.$store.state.company.companies
    },
    contactLists() {
      const selected = this.selectedCompanyIds
      if (!selected.length) {
        return this.$store.state.contact.contacts
      }
      return this.$store.state.contact.contacts.filter(contact => selected.includes(String(contact.company_id)))
    },
    userLists() {
      return this.$store.state.user.users
    },
    selectedCompanyIds() {
      if (this.company) {
        const id = this.resolveCompanyId(this.company)
        return id ? [String(id)] : []
      }
      if (this.localFilters.company_id && this.localFilters.company_id.length) {
        return this.localFilters.company_id.map(id => String(id))
      }
      return []
    },
  },
  created() {
    this.syncFilters()
  },
  watch: {
    value: {
      handler() {
        this.syncFilters()
      },
      deep: true,
    },
  },
  methods: {
    resolveCompanyId(company) {
      if (company && typeof company === 'object') {
        return company.id
      }
      if (company !== '' && company !== null && company !== undefined) {
        return Number(company)
      }
      return null
    },
    defaultFilters() {
      return {
        company_id: [],
        contact_id: [],
        from_user_id: [],
        to_user_id: [],
        dateFrom: '',
        dateTo: '',
        seenPending: true,
        seenRead: true,
        seenDone: false,
      }
    },
    syncFilters() {
      const defaults = this.defaultFilters()
      const value = this.value || {}
      this.localFilters = Object.assign({}, defaults, {
        company_id: Array.isArray(value.company_id) ? value.company_id.slice() : defaults.company_id,
        contact_id: Array.isArray(value.contact_id) ? value.contact_id.slice() : defaults.contact_id,
        from_user_id: Array.isArray(value.from_user_id) ? value.from_user_id.slice() : defaults.from_user_id,
        to_user_id: Array.isArray(value.to_user_id) ? value.to_user_id.slice() : defaults.to_user_id,
        dateFrom: value.dateFrom || defaults.dateFrom,
        dateTo: value.dateTo || defaults.dateTo,
        seenPending: typeof value.seenPending === 'boolean' ? value.seenPending : defaults.seenPending,
        seenRead: typeof value.seenRead === 'boolean' ? value.seenRead : defaults.seenRead,
        seenDone: typeof value.seenDone === 'boolean' ? value.seenDone : defaults.seenDone,
      })
    },
    applyFilters() {
      this.$emit('apply', Object.assign({}, this.localFilters))
    },
    resetFilters() {
      this.localFilters = this.defaultFilters()
      this.$emit('apply', Object.assign({}, this.localFilters))
    },
  },
}
</script>

<style scoped>
.notes-filter-card {
  width: 360px;
  max-width: 90vw;
}
.filter-section-title {
  font-size: 13px;
  color: #6d6d6d;
  margin-bottom: 6px;
}
</style>
